var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.48665C11.78 5.26665 9.54667 5.15332 7.32 5.15332C6 5.15332 4.68 5.21999 3.36 5.35332L2 5.48665",
    stroke: "#F04438",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66797 4.81301L5.81464 3.93967C5.9213 3.30634 6.0013 2.83301 7.12797 2.83301H8.87464C10.0013 2.83301 10.088 3.33301 10.188 3.94634L10.3346 4.81301",
    stroke: "#F04438",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5669 7.59277L12.1336 14.3061C12.0603 15.3528 12.0003 16.1661 10.1403 16.1661H5.86026C4.00026 16.1661 3.94026 15.3528 3.86693 14.3061L3.43359 7.59277",
    stroke: "#F04438",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88672 12.5H9.10672",
    stroke: "#F04438",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33203 9.83301H9.66536",
    stroke: "#F04438",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDel);
export default __webpack_public_path__ + "static/media/del.c8ac412f54186446157ac0dc2f616d22.svg";
export { ForwardRef as ReactComponent };